import { AbstractControl } from '@angular/forms';

export function RequireMatch(control: AbstractControl) {
  const selection: any = control.value;
  if (typeof selection === 'string' && selection.length > 0) {
    return { incorrect: true };
  }
  return null;
}
